<template lang="pug">
  #itineries.center-panel.md-scrollbar.md-theme-default
    .md-layout.heading
    md-content.md-elevation-1(md-theme="white" v-loader-overlay="progress")
      sort-table(
        ref="table" class="itineries-table" 
        v-bind:columns="tableColumns" v-model="itineraries"  
        v-on:refresh="getItineraries" link 
        v-bind:per-page="perPage" 
        v-bind:total="itinerariesAmount" table-id="itinerary" 
        v-on:item-click="onItemClick"
        v-on:create="create"
        v-bind:showAddButton="false"
        v-bind:loadOnScroll="true"
        :refreshOnCreate="false"
      )
        template(slot="freights" slot-scope="scope")  {{ (scope.item && scope.item.freights) ? scope.item.freights.length : ((scope.item.freights_ids) ? scope.item.freights_ids.length : 0) }}

        template(slot="forwarder" slot-scope="scope")
          .no-break-hidden: span {{ scope.item.forwarder !== null ? scope.item.forwarder.login : '' }}

        template(slot="from_stock" slot-scope="scope")
          .no-break-hidden: span {{ scope.item.from_stock ? scope.item.from_stock.name : 'Не установлен' }}

        template(slot="to_stock" slot-scope="scope")
          .no-break-hidden: span {{ scope.item.to_stock ? scope.item.to_stock.name : 'Не установлен' }}

        template(slot="stock" slot-scope="scope")
          .no-break-hidden: span {{ scope.item.stock ? scope.item.stock.name : 'Не установлен' }}

        template(slot="date" slot-scope="scope") {{ scope.item.date ? moment(scope.item.date).format('DD.MM.YYYY') : 'Не установленна' }}

        template(slot="driver" slot-scope="scope") 
          .no-break-hidden: span(v-if="scope.item.driver && scope.item.driver.id") {{ (scope.item.driver && scope.item.driver.fio) ? scope.item.driver.fio : '' }}
          .no-break-hidden: span(v-if="scope.item.forwarder && scope.item.forwarder.id") {{ (scope.item.forwarder && scope.item.forwarder.fio) ? scope.item.forwarder.fio : '' }}

        template(slot="weight" slot-scope="scope")
          .no-break-hidden(v-if="scope.item.weight"): span {{scope.item.weight.toFixed(2)}}
          .no-break-hidden(v-else): span Не указан

        template(slot="size" slot-scope="scope")
          .no-break-hidden(v-if="scope.item.size"): span {{scope.item.size.toFixed(2)}}
          .no-break-hidden(v-else): span Не указан

        template(slot="actions" slot-scope="scope")
          span
            md-button.md-icon-button.md-dense(v-on:click.stop.prevent="showRemoveDialog(scope.item)"): md-icon delete
            md-tooltip(md-direction="top") Удалить машрутный лист
        template(slot="status" slot-scope="scope")
          div(class="itineraries-status" v-bind:style="('color: ' + scope.item.status.color + ';')")
            span {{scope.item.status.message}}
    md-dialog(v-bind:md-active.sync="deleteDialog" md-theme="white")
      md-dialog-title Удалить машрутный лист?
      md-dialog-actions
        md-button.md-primary(@click="deleteDialog = false") Отмена
        md-button.md-accent(@click="deleteItinerary()") Удалить
</template>
<script>
  import moment from "moment";
  import SortTable from "@/components/SortTable";
  export default {
    components: {SortTable},
    metaInfo() {
      return {
        title: 'Маршрутный лист',
        itemToRemove: {},
        deleteDialog: false,
      }
    },
    data() {
      return {
        title: 'Маршрутный лист',
        tableColumns: [
          { label: 'ID', field: 'id', sortable: true},
          { label: 'Тип', field: 'type_name', sortable: true},
          { label: 'Отправление', field: 'from_stock', sortable: true},
          { label: 'Назначение', field: 'to_stock', sortable: true},
          { label: 'Экспедирование', field: 'stock', sortable: true},
          { label: 'Водитель/Экспедитор', field: 'driver', sortable: false},
          { label: 'Дата исполнения', field: 'date', sortable: true},
          { label: 'Статус', field: 'status', sortable: true},
          { label: 'Грузы', field: 'freights', sortable: false},
          { label: 'Кол-во мест', field: 'seats', sortable: false},
          { label: 'Вес (кг)', field: 'weight', sortable: false},
          { label: 'Объём (м<sup>3</sup>)', field: 'size', sortable: false},
          { label: '', field: 'actions'}
        ],
        deleteDialog: false,
        perPage: 50
      }
    },
    computed: {
      itinerariesAmount() {
        return this.$store.state.deals.route_lists_amount;
      },
      itineraries() {
        let itineraries = this.$store.state.deals.route_lists;
        if (!itineraries || !itineraries.length) return [];
        itineraries.map(item => {
          item.routerLink = { name: 'Itinerary', params: { id: item.id }, query: this.$route.query};
        });
        return itineraries;
      },
      progress() {
        return this.progressObj['get-itineraries-list'];
      },
      progressObj() {
        return this.$store.state.progressObj;
      },
    },
    watch: {
      '$route.name'(name, oldName) {
        if (name == 'Itineraries') this.$store.commit('setTitle', 'Маршрутные листы');
        if (name == 'Itineraries' && oldName != 'Itinerary') this.$root.$emit('refresh-table', 'itinerary');
      }
    },
    methods: {
      getItineraries(page, count, orderBy, orderType, f, reload) {
        let filter = null, customFilter = null;
        if (this.$route.query && this.$route.query.custom_filter) customFilter = JSON.parse(this.$route.query.custom_filter);

        this.$store.commit('showProgressBar', 'get-itineraries-list');
        this.$store.commit('deals/setCurrentItinerariesPage', page);
        let params = {
          page:       (page)      ? page      : 1,
          count:      (count)     ? count     : 50,
          order_by:   (orderBy)   ? orderBy   : 'date',
          order_type: (orderType) ? orderType : 'desc',
          filter:     (filter)    ? filter    : {model: [], relation: []},
          custom_filter: (customFilter) ? customFilter : null,
          concat: !reload 
        };
        return this.$store.dispatch('deals/getRouteLists', params).finally(() => {
          this.$store.commit('hideProgressBar', 'get-itineraries-list');
        });
      },
      onItemClick(data) {
        this.toItinerary(data.item);
      },
      toItinerary(item) {
        this.$store.commit('stock/setCurrentItinerary', item);
        this.$router.push({name: 'Itinerary'});
      },
      showRemoveDialog(item) {
        this.itemToRemove = Object.assign({}, item);
        this.deleteDialog = true;
      },
      deleteItinerary() {
        this.deleteDialog = false;
        if (!this.itemToRemove || !this.itemToRemove.freights || !this.itemToRemove.freights.length) return;
        this.$store.dispatch('stock/deleteItinerary', this.itemToRemove.id).then(r => {
          if (r) {
              this.$store.commit('showSnackbar', ['Машрутный лист успешно удалён, обновление списка маршрутных листов...', 6000, 'success']);
              this.getItineraries();
          }
        });
      },
      create() {
        this.$router.push({name: 'Itinerary', params: { id: 'new' }});
      }
    },
    created() {
      this.$store.commit('setBigSizePanel');
      this.$store.commit('setTitle', 'Маршрутные листы');
    },
  }
</script>
<style lang="sass">
    .itineries-table
        tbody
            tr.md-table-row
                cursor: pointer
</style>


// WEBPACK FOOTER //
// Itineraries.vue?5d415846